/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// match css value between "font-family:" and ";"
const parseFont = (font) => font?.match(/:\s(.*?);/, '')?.[1] || null;
export default parseFont;
